import { Container, Row, Col } from "react-bootstrap";
//import '../data/About.css';
import { useTheme, DARK, LIGHT } from "../context/ThemeContext";
import { FaLinkedin } from "react-icons/fa6";
import { FaGithub } from "react-icons/fa6";
import { FaSquareXTwitter } from "react-icons/fa6";
import { SiMedium } from "react-icons/si";
import { FaCloudDownloadAlt } from "react-icons/fa";
import profile2 from '../assets/img/sandhya.jpeg';


export const About = () => {

    const { isDark } = useTheme();
    const t = isDark ? DARK : LIGHT;

    const sectionStyle = {
        background: t.bg,
        padding: '60px 0',
        transition: 'background 0.3s',
    };

    const cardStyle = {
       // background: t.bgAlt,
       // border: `1px solid ${t.border}`,
        borderLeft: `4px solid ${t.accent}`,
        borderRadius: '12px',
        padding: '28px 32px',
        fontSize: '15px',
        lineHeight: '1.85',
        color: t.textMuted,
        transition: 'background 0.3s, border-color 0.3s',
    };

    const socialBtn = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '38px', height: '38px',
        borderRadius: '8px',
        background: t.tagBg,
        border: `1px solid ${t.border}`,
        color: t.textSub,
        fontSize: '18px',
        textDecoration: 'none',
        transition: 'all 0.2s',
        marginRight: '8px',
    };

    return (
        <section id="about" style={sectionStyle}>
            <Container>
               
                <div style={{ textAlign: 'center', marginBottom: '36px' }}>
                    {/* <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '3px', textTransform: 'uppercase', color: t.accent, marginBottom: '8px' }}>
                        Introduction
                    </div> */}
                    <div style={{ fontSize: '26px', fontWeight: 700, letterSpacing: '3px', textTransform: 'uppercase', color: t.accent, marginBottom: '8px'  }}>About Me</div>
                </div>

                <Row className="d-flex align-items-first justify-content-center">
                   
                    <Col xs={12} md={8} className="order-last order-md-first">
                        <div style={cardStyle}> 
                            <p style={{ margin: 0, fontWeight: 'bold', fontStyle: 'italic' }}>
                                Experienced Software Engineer with a passion for crafting robust enterprise
                                and web applications that address both internal and external business needs.
                                With 6+ years of hands-on experience, I specialize in Java and Spring
                                frameworks for backend development, and Angular and React.js for building
                                dynamic, responsive front-end experiences.
                                <br /><br />

                                My expertise extends to designing secure RESTful APIs, optimizing database
                                performance, unit testing, and implementing efficient solutions throughout
                                the Software Development Life Cycle. I hold a Master's in Computer Science
                                and an AWS Cloud Practitioner certification, bringing solid knowledge in
                                cloud computing and AWS services.

                                <br /><br />
                                If you're seeking for a motivated software engineer dedicated to ongoing learning and driving results, I'm excited to connect with you.
                            </p>
                        </div>

                        {/* Social links */}
                                    <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}>
                                      <a href="https://www.linkedin.com/in/khinmyowai-sandhya/" target="_blank" rel="noreferrer" style={socialBtn}><FaLinkedin /></a>
                                     {/* <a href="https://twitter.com/" target="_blank" rel="noreferrer" style={socialBtn}><FaSquareXTwitter /></a> */}
                                      <a href="https://medium.com/@sandhya.khinmyowai_40698" target="_blank" rel="noreferrer" style={socialBtn}><SiMedium /></a>
                                      <a href="https://github.com/SandhyaMIU" target="_blank" rel="noreferrer" style={socialBtn}><FaGithub /></a>
                                    </div>

                    </Col>


                   
          <Col xs={12} md={3} className="order-first order-md-last mb-4 mb-md-0" style={{ marginTop: '40px' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <img
                src={profile2}
                alt="Khin Myo Wai"
                style={{
                  borderRadius: '50%',
                  width: '240px', height: '240px',
                  objectFit: 'cover',
                  border: `2px solid ${t.border}`,
                  boxShadow: t.shadow,
                }}
              />
            </div>
          </Col>

                    
                    {/* <Col xs={12} md={3} className="order-first order-md-last mb-3">
                        <div className="d-flex align-items-center justify-content-center">
                            <img
                                src={profile2} // Replace with your photo URL
                                alt="Photo"
                                style={{ borderRadius: '50%', width: '260px', height: '260px', objectFit: 'contain', border: '1px solid #fff' }}
                            />
                        </div>

                    </Col> */}
                </Row>

            </Container>

        </section>
    )
}